<template>
  <div class="page-full flex-container">
    <back-nav/>
    <div class="flex-scroll">
      <div class="card">
        <div class="card-title">订单采购融资</div>
        <div class="card-cont">
          <ul class="card-left">
            <li><span class="square"></span> 基于特定上游申请</li>
            <li><span class="square"></span> 用于支付采购款项</li>
            <li><span class="square"></span> 额度化产品 灵活便利</li>
          </ul>
          <div class="card-right"><img src="@/assets/images/finance.png"></div>
        </div>
        <van-button type="primary" block @click="goOrderFinan">点击进入</van-button>
      </div>
      <div class="link-btn" @click="entryChannel">渠道客户入口</div>
    </div>
  </div>
</template>

<script>
import {Vue, Component} from "vue-property-decorator";

@Component({
  name: "FinancialServices"
})
export default class FinancialServices extends Vue {
  goOrderFinan(){
    // if(!this.$action('orderFinance')){
    //   return false
    // }
    this.$router.push('/orderFinance')
  }
  entryChannel(){
    // if(!this.$action('entryChannel')){
    //   return false
    // }
    this.$bridge.callHandler('entryChannel')
  }
}
</script>

<style scoped lang="less">
.card {
  margin: 12px 16px;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(73, 82, 99, 0.05);
  border-radius: 8px;
  text-align: left;
  overflow: hidden;

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    padding: 24px 24px 0px 24px;
  }

  .card-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 26px;

    .card-left {
      margin-left: 24px;
      margin-top: 8px;

      li {
        margin-top: 8px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;

        .square {
          display: inline-block;
          border-radius: 50%;
          width: 2px;
          height: 2px;
          background: #666666;
          vertical-align: super;
        }
      }
    }

    .card-right {
      margin-right: 32px;
      img{
        height: 88px;
      }
    }
  }

}

/deep/.van-button{
  height: 30px;
  border-radius: 0px;
}

.link-btn{
  margin-top: 26px;
  font-size: 14px;
  color: @main-color6;
}
</style>
